import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface InputRadioOption {
  label: string;
  value: any;
}

@Component({
  selector: 'app-input-radio-group',
  templateUrl: './input-radio-group.component.html',
  styleUrls: ['./input-radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioGroupComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class InputRadioGroupComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() options: InputRadioOption[] = [];
  @Input() columns: number = 2;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  value: any = null;

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  isSelected(value: any): boolean {
    return String(value) === String(this.value);
  }

  select(value: any): void {
    if (this.disabled || this.readonly) return;
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  trackByValue(_index: number, option: InputRadioOption): any {
    return option.value;
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
